export const netflixTitle = "Plataforma Netflix";
export const netflixText =
  "Disfruta de todo el catálogo completo de Netflix. Series, películas, documentales y mucho más para cuando tú quieras.";
export const disneyTitle = "Plataforma Disney+";
export const disneyText =
  "Entretenimiento sin límites con Disney, Pixar, Marvel, Star Wars, National Geographic y Star, todo en un mismo lugar.";
export const daznTitle = "Plataforma DAZN";
export const daznText =
  "Ya puedes disfrutar DAZN en tu TV. Para verlo en tus dispositivos debes crear tu cuenta y  disfrutarlo en la app DAZN y en dazn.com.";
export const titleProviderTv = "Acceso a plataformas de TV incluidas";
export const buttonText = "Alta y baja de contenidos";

export const TELEVISION = "7";
export const OTROS = "47";

export const DISNEY_ACTIVATED = "1113";

export const INCLUDED = "Incluido en tu pack";
export const CONTRACTED = "Contratado";

export const PROVIDER_ID_DAZN = "dazn";
export const PROVIDER_ID_MAX = "max";
export const PROVIDER_ID_DISNEY = "disney";
export const PROVIDER_ID_APPLETV = "appletv";
export const PROVIDER_ID_SKY = "skyshowtime";
export const PROVIDER_ID_FLIXOLE = "flixole";


export const NO_ACTIVATED_STATE = "1";
export const ACTIVATED_STATE = "2";